import React from 'react';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons/faCheckCircle';

import { numToLetter } from '~/commons/helpers';

// const checkAnswer = (answer = [], answered = []) => {
//   if (answer.length !== answered.length) return false;
//   const [ans, ansed] = [answer.sort(), answered.sort()];
//   return ans.every((a, i) => a === ansed[i]);
// };

const AnswerChoices = ({
  onClick = () => {},
  question: { choices, answer },
  answered,
  chose = [],
}) => {
  const { i18n } = useTranslation();
  // const isCorrect = checkAnswer(answer, answered);

  return (
    <div className="d-grid gap-4">
      {choices.map((c, i) => (
        <button
          key={c._id}
          type="button"
          className={`
            btn rounded-pill bg-white shadow text-start
            fs-5 fw-bold px-4 py-3
            ${chose?.includes(i) ? 'border-5 border-primary' : ''}
          `}
          onClick={() => {
            if (answered === undefined) {
              onClick(i);
            }
          }}
        >
          <div className="d-flex">
            <div className="flex-fill">
              {numToLetter(i).toUpperCase()}
              .
              {' '}
              {i18n.pickLng(c)}
            </div>
            {(answered?.includes(i) || answer.includes(i)) && answered && (
              <div className={answer.includes(i) ? 'text-success' : 'text-danger'}>
                <FA icon={answer.includes(i) ? faCheckCircle : faTimesCircle} />
              </div>
            )}
          </div>
        </button>
      ))}
    </div>
  );
};

export default AnswerChoices;
